export const FILE_DATA = "boilderplate/GSTR2X/SAVE/FILE_DATA";
// export const FILE_DATA = "boilderplate/GSTR2X/PREPARE/FILE_DATA";
export const LOADER_STATUS = "boilderplate/GSTR2X/SAVE/LOADER_STATUS";
export const STORE_PERIOD = 'boilerplate/GSTR2X/SAVE/STORE_PERIOD';
export const SET_PREVIEW_TABLE_DATA = 'boilerplate/GSTR2X/SAVE/SET_PREVIEW_TABLE_DATA';
export const SET_COMPARATIVE_TABLE_DATA = 'boilerplate/GSTR2X/SAVE/SET_COMPARATIVE_TABLE_DATA';

